import Vue from 'vue';
import Value from './value.vue';

const groupId = document.getElementById('group_id').value;

new Vue({
  el: '#value',
  render: createElement => createElement(Value, {
      props: {
          groupId: parseInt(groupId)
      }
  })
})
